module.exports = __webpack_public_path__ + "img/energy_filled.1fb18c47.png";